import { MdOutlineGroup, MdFactory } from "react-icons/md";
import { FaDollarSign } from "react-icons/fa6";
import { FaLinkedin } from 'react-icons/fa';
import { trackPageView} from '../../utlis/useAnalytics';
import { useEffect } from "react";
import {PageName} from '../../configs/config'
import { Helmet } from "react-helmet-async";
// Import team member profile pictures
import Arjun from "./assets/profilepics/arjun.webp";
import Abhishek from "./assets/profilepics/abhishek.webp";
import Akhil from "./assets/profilepics/akhil.webp";
import Anil from "./assets/profilepics/anil.webp";
import Bhupi from "./assets/profilepics/bhupi.webp";
import Camillus from "./assets/profilepics/camillus.webp";
import Deepak from "./assets/profilepics/deepak.webp";
import Dipankar from "./assets/profilepics/dipakar.webp";
import Jerin from "./assets/profilepics/jerin.webp";
import John from "./assets/profilepics/john.webp";
import Junaid from "./assets/profilepics/junaid.webp";
import Manish from "./assets/profilepics/manish.webp";
import Mohan from "./assets/profilepics/mohan.webp";
import Nikita from "./assets/profilepics/nikita.webp";
import Roshan from "./assets/profilepics/roshan.webp";
import Sajjan from "./assets/profilepics/Sajjan.webp";
import Syed from "./assets/profilepics/syed.webp";
import Chinmay from "./assets/profilepics/chinmay.webp";
import Male from "./assets/profilepics/male.webp";
import Female from "./assets/profilepics/female.webp";
import Ash from "./assets/profilepics/Ash.webp"

/**
 * AboutUs Component
 * 
 * Displays information about EximPe including company overview, statistics,
 * culture, and team members with their profiles.
 */
export default function Aboutus() {
  useEffect(() => {
    trackPageView(PageName.AboutEximpe);
  }, []);

  
  // Team member data array for cleaner rendering
  const teamMembers = [
    { img: Arjun, name: "Arjun Zacharia", role: "Founder, CEO​", linkedin: "https://www.linkedin.com/in/arjunabrahamzacharia/" },
    { img: Camillus, name: "Camillus Carvalho", role: "Business​", linkedin: "https://www.linkedin.com/in/camillus-carvalho-7b080735/" },
    { img: John, name: "John Peter​", role: "Product​", linkedin: "https://www.linkedin.com/in/john-peter-669a9480/" },
    { img: Male, name: "Bosco Caldeira​", role: "Partnerships", linkedin: "" },
    { img: Female, name: "Batul Rampurawala", role: "Operations", linkedin: "https://www.linkedin.com/in/batul-rampurawala-714719b2/" },
    { img: Sajjan, name: "Sajjan Kumar Agarwal​", role: "Risk and Compliance", linkedin: "" },
    { img: Mohan, name: "Mohan Bhaktha", role: "Head - Compliance", linkedin: "https://www.linkedin.com/in/ramesh-iyer-6bb110178/" },
    { img: Jerin, name: "Jerin Viju​", role: "Engineering​", linkedin: "https://www.linkedin.com/in/jerin-viju-988103115/" },
    { img: Akhil, name: "Akhil Kumar​", role: "Engineering​", linkedin: "https://www.linkedin.com/in/akhil-kumar-m-g-b19727110/" },
    { img: Roshan, name: "Roshan Abhishek​", role: "Engineering​", linkedin: "https://www.linkedin.com/in/roshan-abhishek-82b695109/" },
    { img: Abhishek, name: "Abhishek Chandrasenan​", role: "Engineering​", linkedin: "https://www.linkedin.com/in/theshakeabhi/" },
    { img: Deepak, name: "Deepak Chandel​", role: "Growth​", linkedin: "https://www.linkedin.com/in/deepakchandel/" },
    { img: Anil, name: "Anil Vignesh​", role: "Product​", linkedin: "https://www.linkedin.com/in/anil-vignesh/" },
    { img: Dipankar, name: "Dipankar Biswas​", role: "Growth​", linkedin: "https://www.linkedin.com/in/globalvyapar/" },
    { img: Manish, name: "Manish Pandey​", role: "Business Development", linkedin: "https://www.linkedin.com/in/manish-pandey-52664b198/" },
    { img: Nikita, name: "Nikita Bhutoria​", role: "Legal​", linkedin: "https://www.linkedin.com/in/nikita-bhutoria-678a14151/" },
    { img: Syed, name: "Syed Arief Ulla", role: "Growth", linkedin: "" },
    { img: Bhupi, name: "Bhupeendar KB", role: "Business Development", linkedin: "" },
    { img: Junaid, name: "Mohammed Junaid", role: "Growth", linkedin: "" },
    { img: Chinmay, name: "Chinmay Bhat", role: "Product and Marketing", linkedin: "https://www.linkedin.com/in/chinmaybhat03" },
    { img: Ash, name: "Ash", role: "Product and Marketing", linkedin: "" },
    { img: Female, name: "Haseena", role: "Business Development", linkedin: "" }
  ];

  return (
        <><Helmet>
      <title>About Eximpe: Empowering Global Trade & Finance in India</title>
      <meta name="description" content="Learn about Eximpe's mission to simplify international trade, payments, and financial compliance for businesses and individuals across India." />
    </Helmet>
    <div className="bg-gray-50 mt-10 lg:mt-0 pb-16">
        <div className="container mx-auto px-4 sm:px-6 lg:px-8 max-w-7xl">
          {/* Company Overview Section - Added consistent padding and fixed spacing */}
          <div className="pt-16 md:pt-24 lg:pt-28">
            <h1 className="text-3xl sm:text-4xl md:text-5xl text-center font-bold text-slate-900 tracking-tight mb-4 sm:mb-6">
              About EximPe
            </h1>
            <p className="text-lg sm:text-xl text-slate-600 text-center max-w-3xl mx-auto px-2 sm:px-4">
              EximPe, by Les Amis Pvt Ltd, is your one-stop solution for seamless cross-border payments.
              Our state-of-the-art technology ensures secure, efficient, and reliable transactions for
              businesses of all sizes.
            </p>

            {/* Statistics Section - Improved responsive grid */}
            <div className="mt-12 sm:mt-16 md:mt-20 grid grid-cols-1 gap-4 sm:gap-6 md:gap-8 sm:grid-cols-3">
              <div className="bg-white rounded-2xl shadow-sm hover:shadow-md transition-all p-6 md:p-8 text-center">
                <div className="flex justify-center">
                  <MdOutlineGroup className="h-10 w-10 md:h-12 md:w-12 text-[#169a86]" />
                </div>
                <div className="mt-4">
                  <p className="text-3xl md:text-4xl font-bold text-slate-900">5</p>
                  <p className="mt-2 text-slate-600">Cities</p>
                </div>
              </div>
              <div className="bg-white rounded-2xl shadow-sm hover:shadow-md transition-all p-6 md:p-8 text-center">
                <div className="flex justify-center">
                  <MdFactory className="h-10 w-10 md:h-12 md:w-12 text-[#169a86]" />
                </div>
                <div className="mt-4">
                  <p className="text-3xl md:text-4xl font-bold text-slate-900">25</p>
                  <p className="mt-2 text-slate-600">Employees</p>
                </div>
              </div>
              <div className="bg-white rounded-2xl shadow-sm hover:shadow-md transition-all p-6 md:p-8 text-center">
                <div className="flex justify-center">
                  <FaDollarSign className="h-10 w-10 md:h-12 md:w-12 text-[#169a86]" />
                </div>
                <div className="mt-4">
                  <p className="text-3xl md:text-4xl font-bold text-slate-900">$4M</p>
                  <p className="mt-2 text-slate-600">Funding</p>
                </div>
              </div>
            </div>

            {/* Company Details Section - Improved readability and spacing */}
            <div className="mt-12 sm:mt-16 md:mt-20 px-4 sm:px-6 max-w-4xl mx-auto text-slate-600">
              <p className="mb-4 sm:mb-6 text-base sm:text-lg">
                At EximPe, we believe that every business should have the opportunity to expand globally,
                without the hassle of complex cross-border payments. That's why we've developed a
                cutting-edge solution that streamlines the process and provides peace of mind.
              </p>
              <p className="mb-4 sm:mb-6 text-base sm:text-lg">
                Our leadership team has over 100 years of combined experience in the trade and finance domain.
                Their vision is brought into reality by the tech team comprising of young professionals
                working with the latest technologies, dedicated to innovation and customer satisfaction.
              </p>
              <p className="mb-4 sm:mb-6 text-base sm:text-lg">
                We believe in fostering a positive, inclusive culture that encourages creativity,
                collaboration, and continuous learning. Our team members come from diverse backgrounds,
                and we value the unique perspectives and skills that each individual brings to the table.
              </p>
              <p className="mb-4 sm:mb-6 text-base sm:text-lg">
                We prioritise work-life balance and provide a flexible schedule, we also organise team
                building activities and fun events, the goal is to build a strong sense of community
                and camaraderie among our team.
              </p>
              <p className="text-base sm:text-lg">
                We take pride in the fact that every team member feels respected and valued, and that our workplace is a place where everyone can be their true selves. This inclusivity and diversity of thought is what makes EximPe culture unique and help us to develop a better solution for our customers.
              </p>
            </div>

            {/* Team Section - Improved spacing and titles */}
            <div className="mt-12 sm:mt-16 md:mt-20 text-center">
              <h2 className="text-2xl sm:text-3xl md:text-4xl lg:text-5xl font-bold text-slate-900">Our Team</h2>
            </div>

            {/* Team Grid - Improved responsive layout */}
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-4 sm:gap-6 md:gap-8 mt-8 sm:mt-10">
              {teamMembers.map((member, index) => (
                <div key={index} className="flex flex-col items-center p-4 sm:p-6 md:p-8 rounded-xl bg-white shadow-sm hover:shadow-md transition-all">
                  <div className="relative w-full aspect-square overflow-hidden rounded-lg">
                    <img
                      src={member.img}
                      alt={member.name}
                      className="w-full h-full object-cover" />
                    {member.linkedin && (
                      <a
                        href={member.linkedin}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="absolute inset-0 flex items-center justify-center bg-black bg-opacity-50 opacity-0 hover:opacity-100 transition-opacity duration-300"
                      >
                        <FaLinkedin className="text-white h-8 w-8 sm:h-10 sm:w-10" />
                      </a>
                    )}
                  </div>
                  <p className="text-slate-900 font-bold mt-3 sm:mt-4 text-center text-lg sm:text-xl truncate w-full">
                    {member.name}
                  </p>
                  <p className="text-slate-600 mt-1 sm:mt-2 text-sm sm:text-base truncate w-full text-center">
                    {member.role}
                  </p>
                </div>
              ))}
            </div>

            {/* Careers CTA Section - Improved spacing and sizing */}
            <div className="mt-12 sm:mt-16 md:mt-20 text-center">
              <p className="font-bold text-xl sm:text-2xl text-slate-900 px-4 max-w-2xl mx-auto">
                Sounds like the place you want to be? We have a bunch of open positions
              </p>
              <a
                href="https://wellfound.com/company/eximpe-2"
                className="mt-4 sm:mt-6 inline-block bg-[#26a887] text-white rounded-lg px-5 py-2 sm:px-6 sm:py-3 md:px-8 md:py-3 hover:bg-[#034435] transition-all duration-300 hover:scale-105 font-medium"
              >
                Explore Positions
              </a>
            </div>
          </div>
        </div>
      </div></>
  );
}